<template>
  <v-layout row wrap>
    <v-flex v-if="!showOrder" xs10 offset-lg1>
<!-- no events found dialog -->
      <!-- <div class="text-xs-center">
        <v-dialog width="500" persistent v-model="noEventsFound">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>{{$translate('NO_EVENT')}}</v-card-title>
            <v-card-text v-if="$store.getters.getSavePartnerId !== ''">{{$translate('NO_EVENTS_NOW_FOR_PARTNER')}}</v-card-text>
            <v-card-text v-else>{{$translate('NO_EVENTS_NOW_FOR_ACCOUNT')}}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="noEventsFound = false">{{$translate('CLOSE')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div> -->
      <v-card id="screen">
        <v-toolbar color="primary" dark>
          <v-toolbar-title v-if="showEventData">Booking your trip</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
       <!-- <v-layout align-center justify-center row fill-height v-if="showProgessCircle">
          <v-progress-circular :size="50" :width="7" color="primary" indeterminate></v-progress-circular>
          <h2
            v-if="showProgressText"
            :style="`color: ${$vuetify.theme.primary}`"
          >{{$translate('LINDA_GETTING_EVENTS')}}</h2>
          <h2
            v-else-if="!showProgressText"
            :style="`color: ${$vuetify.theme.primary}`"
          >{{$translate('LINDA_SEARCHING')}}</h2>
        </v-layout>
        <v-card v-if="showCalendar" id="v-card" elevation-0>
          <v-card class="notificationList elevation-0">
            <template v-for="(item, index) in $store.getters.getCalendar">
              <v-subheader :key="index + '-' + item" class="date mt-1">{{ index }}</v-subheader>
              <v-card id="getEventDetails" flat v-for="(eventData, key) in item" :key="index + '-' + key">
                  <v-layout ml-2 mt-2 @click="getEventDetails(eventData, index, false)">
                      <v-avatar class="avatarOfCalendar">
                      <img v-if="eventData.Picture !== 'NULL'" :src="eventData.Picture">
                      <img
                        v-else
                        src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                      >
                    </v-avatar>
                    <v-layout class="ml-2 column">
                      <h3>{{eventData.Name}}</h3>
                      <p class="suggestionsTime" v-if="eventData.BatchFrequency > 0"
                        >{{eventData.StartTime}} - {{eventData.EndTime}}, {{$translate('EVENT_STARTS_EVERY')}} {{(eventData.BatchFrequency / 60).toFixed(0)}} {{$translate('MINUTES')}}
                      </p>
                      <p class="suggestionsTime" v-if="eventData.BatchFrequency > 0">
                        {{$translate('EVENT_DURATION')}} {{(eventData.Duration / 60).toFixed(0)}} {{$translate('MINUTES')}}
                      </p>
                      <p class="suggestionsTime"  v-else
                          >{{eventData.StartTime}} - {{eventData.EndTime}}, {{$translate('EVENT_DURATION')}} {{(eventData.Duration  / 60).toFixed(0)}} {{$translate('MINUTES')}}
                      </p>
                    </v-layout>
                     <v-list-tile-action>
                        <v-list-tile-action-text id="price">€{{ eventData.Price.toFixed(2) }}</v-list-tile-action-text>
                      </v-list-tile-action>
                    </v-layout>
                  <v-card flat v-if="extraEventInfo && chosenEventId == eventData.EventId && chosenDate == index && eventData.BatchGroupId == chosenBatchGroupId" >
                    <v-layout class="calendar-expansion-content" ma-2 row>
                      <v-card-text class="lighten-3">{{eventDescription}}</v-card-text>
                      <img
                        :aspect-ratio="14/9"
                        class="suggestionsImage"
                        v-if="!eventPicture == ''"
                        :src="eventPicture"
                      >
                      <img
                        :aspect-ratio="14/9"
                        class="suggestionsImage"
                        v-else
                        src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                      >
                    </v-layout>
                  </v-card>
                </v-card>
            </template>
          </v-card>
        </v-card> -->
<!-- Input screen for event -->
       <v-dialog v-model="calendarFullScreenDialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
         <v-toolbar class="availableV-Card" color="primary" dark>
           <v-btn icon dark @click="calendarFullScreenDialog = false">
             <v-icon>close</v-icon>
           </v-btn>
           <v-toolbar-title>Order details</v-toolbar-title>
         </v-toolbar>
        <v-card v-if="showEventData" class="elevation-0">
          <v-layout class="eventBlock" pa-4 column>
            <v-stepper v-model="stepperSteps" vertical>
              <v-stepper-step :complete="stepperSteps > 1" step="1">Event details</v-stepper-step>
              <v-stepper-content step="1">
                <v-layout class="eventBlock-layout row">
                  <v-flex xs6 >
                    <h2 class="eventBlock-Name">{{eventDetails.Name}}</h2>
                    <v-card flat class="descriptionV_Card">
                      <p>{{eventDescription}}</p>
                    </v-card>
                    <h3>{{$translate('OPENED_AT')}} - {{eventDetails.StartTime}}</h3>
                    <h3>{{$translate('CLOSED_AT')}} - {{eventDetails.EndTime}}</h3>
                    <h2 style="margin-top: 3em;">Choose products</h2>
                    <template  v-for="(item, index) in eventData.PriceCategories">
                      <v-card-text class="tickets" :key="index">
                        <v-spacer></v-spacer>
                        <h3 style="margin-bottom:-2em">{{item.Name}}</h3>
                        <v-layout row>
                          <v-layout align-end justify-start>
                            <p>€ {{item.Price}}</p>
                          </v-layout>
                          <v-layout align-start justify-end row >
                            <v-text-field
                              v-model="item.Amount"
                              class="countTickets"
                              type="number"
                              min="0"
                              max="10"
                              placeholder="0"
                              max-lenght="2">
                            </v-text-field>
                          </v-layout>
                        </v-layout>
                      </v-card-text>
                    </template>
                    <p>If there are any remarks for the above selections, please let the company know this by adding your remarks here:</p>
                    <v-textarea
                      solo
                      v-model="remark"
                      type="text"
                      placeholder="Place add your remark here">
                    </v-textarea>
                  </v-flex>
                  <v-flex xs6>
                    <!-- If the image data is empty it has a no image picture -->
                    <v-img
                      class="imageForEvent"
                      v-if="!eventPicture == ''"
                      max-height="600"
                      max-width="850"
                      :src="eventPicture"
                    ></v-img>
                    <v-img
                      v-else
                      max-height="200"
                      max-width="100"
                      src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                    ></v-img>
                  </v-flex>
                </v-layout>
                <v-btn color="primary" round @click="goToSecondStep()">{{$translate('NEXT')}}</v-btn>
              </v-stepper-content>
              <v-stepper-step :complete="stepperSteps > 2" step="2">User data</v-stepper-step>
              <v-stepper-content step="2">
                <v-form ref="eventData">
                  <v-flex mt-4 xs12>
                    <v-layout class="ticketsmain" column v-if="NoFrequency > 0">
                      <v-flex>
                        <v-layout row justify-space-around>
                          <v-flex xs5>
                            <h3 :style="`color: ${$vuetify.theme.primary}`" class="requestclient1">{{$translate('REQUEST_CLIENT1')}}</h3>
                            <v-select :items="allBatches" v-model="currentBatch"  item-text="TotalTime" return-object persistent-hint :label="$translate('SELECT_TIME')" solo></v-select>
                            <h3 :style="`color: ${$vuetify.theme.primary}`" class="requestclient1">{{$translate('PHONE_NR')}}</h3>
                            <v-text-field
                              :label="$translate('PHONE_NR')"
                              v-model="userInputs[19]"
                            ></v-text-field>
                            <h3 :style="`color: ${$vuetify.theme.primary}`" class="requestclient1">{{$translate('CITY')}}</h3>
                            <v-text-field
                              :label="$translate('CITY')"
                              v-model="userInputs[17]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5>
                            <h3 :style="`color: ${$vuetify.theme.primary}`" class="requestclient1">{{$translate('STREET')}}</h3>
                            <v-text-field
                              :label="$translate('STREET')"
                              v-model="userInputs[14]"
                            ></v-text-field>
                            <h3 :style="`color: ${$vuetify.theme.primary}`" class="requestclient1">{{$translate('HOUSE_NUMBER')}}</h3>
                            <v-text-field
                              :label="$translate('INCIDENT_NUMMER')"
                              v-model="userInputs[15]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6></v-flex>
                  <v-flex xs12>
                    <v-btn
                      round
                      class="text-capitalize"
                      @click="goTo('Home')"
                      color="secondary"
                    >{{$translate('LINDA_CANCEL_ORDER')}}</v-btn>
                    <v-btn
                      round
                      class="text-capitalize"
                      @click="bookBatch()"
                      color="primary"
                    >{{$translate('BOOK')}}</v-btn>
                  </v-flex>
                </v-form>
                <div>
                  <v-dialog
                    width="500"
                    persistent
                    v-model="emptyInputs"
                  >
                    <v-card>
                      <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                      >
                        Nothing filled in
                      </v-card-title>
                      <v-card-text>
                        The input fields are empty.
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="emptyInputs = false">Close</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    width="500"
                    persistent
                    v-model="cantBookBatch"
                  >
                    <v-card>
                      <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                      >
                        Can't book batch
                      </v-card-title>
                      <v-card-text>
                        It was not possible to book this time slot.
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="cantBookBatch = false">Close</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
                <div class="text-xs-center">
                  <v-dialog width="500" persistent v-model="groupSizeDialog">
                    <v-card>
                      <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                      >{{$translate('NO_CAPACITY')}}</v-card-title>
                      <v-card-text>{{$translate('LINDA_BIGGER_GAP_OR_GROUPSIZE')}}</v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          flat
                          @click="groupSizeDialog = false"
                        >{{$translate('CLOSE')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog width="500" persistent v-model="alertDialog">
                    <v-card>
                      <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                      >{{$translate('WRONG_INPUT')}}</v-card-title>
                      <v-card-text>{{$translate('INPUT_NOT_COMPLETE')}}</v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="alertDialog = false">{{$translate('CLOSE')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
                <div class="text-xs-center">
                  <v-dialog width="500" persistent v-model="timeInCorrect">
                    <v-card>
                      <v-card-title class="headline grey lighten-2" primary-title>{{$translate('EVENT_TIME_INCORRECT')}}</v-card-title>
                      <v-card-text>{{$translate('EVENT_INPUT_TIME_INCORRECT')}}</v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          flat
                          @click="timeInCorrect = false"
                        >{{$translate('CLOSE')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </v-stepper-content>
              <v-stepper-step :complete="stepperSteps > 3" step="3">Order</v-stepper-step>
              <v-stepper-content step="3">
                <v-card v-if="orderOverview" class="transparent elevation-0">
                  <template>
                    <v-flex xs12 d-flex>
                      <h3>Your order id: {{userOrder.OrderId}}</h3>
                    </v-flex>
                    <v-flex xs12 d-flex>
                      <template v-for="(item, index) of userOrder.Order">
                        <v-card
                          class="tripDetail elevation-0"
                          :key="index"
                        >
                          <v-layout row>
                            <v-avatar>
                              <img v-if="!item.Picture == ''" :src="item.Picture">
                              <img
                                v-else
                                src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                              >
                            </v-avatar>
                            <v-card-text>
                              <h4>{{ item.Name }}</h4>
                              <p class="orderText">{{item.StartDate}}, {{item.StartTime}} - {{item.EndTime}}</p>
                              <p class="orderText">{{item.PriceCategoryDescription}}, {{item.GroupSize}}</p>
                              <v-layout justify-end align-end>
                                <p>Activity Price: {{item.ActivityTotalPrice}}</p>
                              </v-layout>
                              <v-divider></v-divider>
                            </v-card-text>
                          </v-layout>
                        </v-card>
                      </template>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="mr-2" xs12 d-flex>
                      <v-layout justify-end align-end>
                        Total price: {{userOrder.OrderTotalPrice}}
                      </v-layout>
                    </v-flex>
                  </template>
                  <v-spacer></v-spacer>
                  <v-btn
                    round
                    class="text-capitalize"
                    color="secondary"
                    @click="stepperSteps = 2"
                  >
                    {{$translate('LINDA_CANCEL_ORDER')}}
                  </v-btn>
                  <v-btn
                    round
                    class="text-capitalize"
                    color="primary"
                    @click="confirmOrderLoading()"
                  >
                    {{$translate('LINDA_CONFIRM_ORDER')}}
                  </v-btn>
                </v-card>
              </v-stepper-content>
            </v-stepper>
          </v-layout>
        </v-card>
       </v-dialog>
      </v-card>
    </v-flex>
    <div class="text-xs-center">
      <v-dialog v-model="showLoading" persistent max-width="390">
        <v-card class="confirmLoadingDialog">
          <v-layout column justify-center align-start>
            <v-card-title class="headline">Order info</v-card-title>
            <v-card-text>
              <p class="setFontSize" >Your order has been received.</p>
              <p
                class="setFontSize"
                v-if="userOrder.OrderTotalPrice !== '0'"
              >You will be automatically redirected to the payment page</p>
              <p
                v-else
                class="setFontSize"
              >You will be automatically redirected to your appointments</p>
            </v-card-text>

            <v-progress-linear :indeterminate="true"></v-progress-linear>
          </v-layout>
        </v-card>
      </v-dialog>
      <v-dialog
        width="500"
        persistent
        v-model="freeTripDialog"
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Order saved
          </v-card-title>
          <v-card-text>
            The order is saved. you will be returned to the 'My activities' page.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        width="500"
        persistent
        v-model="emptyInputs"
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Nothing filled in
          </v-card-title>
          <v-card-text>
            The input fields are empty.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="emptyInputs = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
<!-- Order screen of event  -->
    <v-flex v-if="showOrder" class="order" xs12 sm6 offset-sm3>
      <v-layout row justify-center>
        <v-dialog persistent v-model="confirmOrderDialog" max-width="290">
          <v-card>
            <v-layout align-center justify-center row fill-height v-if="confirmOrderDialog">
              <v-progress-circular :size="50" :width="7" color="primary" indeterminate></v-progress-circular>
            </v-layout>
            <h2
              id="dialog-text"
              :style="`color: ${$vuetify.theme.primary}`"
            >{{$translate('TICKET_ORDER_1')}}</h2>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-card v-if="showOrder" id="showOrder">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{$translate('LINDA_CHECK_YOUR_ORDER')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout class="order" pa-4 column>
          <v-flex xs12>
<!--            <template>-->
<!--              <h3>{{$translate('LINDA_FOOD_AND_BEVERAGE')}}</h3>-->
<!--              <span>{{$translate('ARRIVAL')}}</span>-->
<!--&lt;!&ndash; Timeline for the trip &ndash;&gt;-->
<!--              <v-timeline :style="`color: ${$vuetify.theme.primary}` " dense>-->
<!--                <v-timeline-item v-if="plusBefore">-->
<!--                  <template v-slot:icon>-->
<!--                    <v-btn-->
<!--                      fab-->
<!--                      class="v-btn-tiny mr-2"-->
<!--                      color="primary"-->
<!--                      @click="showSuggestionsSelection('Backward')"-->
<!--                    >-->
<!--                      <v-icon>add</v-icon>-->
<!--                    </v-btn>-->
<!--                  </template>-->
<!--                  <span class="test">{{$translate('LINDA_ADD_FOOD_BEFORE')}}</span>-->
<!--                </v-timeline-item>-->
<!--                <template v-for="(tripActivity, dataOfSuggestion) in fullTrip">-->
<!--                  <v-timeline-item-->
<!--                    :key="dataOfSuggestion"-->
<!--                    large-->
<!--                    color="white"-->
<!--                    v-if="tripActivity.Name !== 'End' && tripActivity.Name !== 'Start' && tripActivity.Name !== 'Walking'"-->
<!--                  >-->
<!--                    <template v-slot:icon>-->
<!--                      &lt;!&ndash; If the image data is empty it has a no image picture &ndash;&gt;-->
<!--                      <v-avatar-->
<!--                      :key="dataOfSuggestion"-->
<!--                      >-->
<!--                        <img v-if="tripActivity.Picture !== ''" v-bind:src="tripActivity.Picture">-->
<!--                        <img-->
<!--                          v-else-->
<!--                          src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"-->
<!--                        >-->
<!--                      </v-avatar>-->
<!--                    </template>-->
<!--                    <template>-->
<!--                      <v-card v-if="tripActivity.Type == 'Standard'" :key="dataOfSuggestion" class="elevation-2 pa-3">-->
<!--                        <v-card-title id="no-padding" class="headline">{{tripActivity.Name}}</v-card-title>-->
<!--                        <v-card-text id="no-padding">-->
<!--                          {{$translate('EVENT_START_TIME')}}:-->
<!--                          <b>{{tripActivity.StartTime}}</b>-->
<!--                          , {{$translate('EVENT_END_TIME')}}:-->
<!--                          <b>{{tripActivity.EndTime}}</b>-->
<!--                          , {{$translate('LINDA_GROUP_SIZE')}}:-->
<!--                          <b>{{tripActivity.GroupSize}}</b>-->
<!--                        </v-card-text>-->
<!--                      </v-card>-->
<!--                      <v-card v-if="tripActivity.Type == 'Tour'" :key="dataOfSuggestion" class="elevation-2 pa-3">-->
<!--                       <v-layout row>-->
<!--                         <v-layout column>-->
<!--                            <v-card-title id="no-padding" class="headline">{{tripActivity.Name}}</v-card-title>-->
<!--                            <v-card-text id="no-padding">-->
<!--                              {{$translate('EVENT_START_TIME')}}:-->
<!--                              <b>{{tripActivity.StartTime}}</b>-->
<!--                              , {{$translate('EVENT_END_TIME')}}:-->
<!--                              <b>{{tripActivity.EndTime}}</b>-->
<!--                              , {{$translate('LINDA_GROUP_SIZE')}}:-->
<!--                              <b>{{tripActivity.GroupSize}}</b>-->
<!--                            </v-card-text>-->
<!--                         </v-layout>-->
<!--                          <v-card-actions v-if="Object.keys(tripActivity.Children).length > 0"><v-btn @click="tourOpened == false ? tourOpened = true : tourOpened = false ">{{openCloseTour}}</v-btn></v-card-actions>-->
<!--                       </v-layout>-->
<!--                        <template class="mt-2" v-if="tourOpened">-->
<!--                          <div v-for="(tripChildActivity, tripChildActivityId) in tripActivity.Children" :key="tripChildActivityId">-->
<!--                            <v-card class="elevation-2 pa-3 tourElements" v-if="tripChildActivity.Type == 'Standard'">-->
<!--                              <v-layout row>-->
<!--                                <v-avatar class="mr-4" :key="tripChildActivityId">-->
<!--                                <img v-if="tripChildActivity.Picture !== ''" v-bind:src="tripChildActivity.Picture">-->
<!--                                <img-->
<!--                                  v-else-->
<!--                                  src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"-->
<!--                                >-->
<!--                                </v-avatar>-->
<!--                                <v-layout column>-->
<!--                                  <v-card-title id="no-padding" class="headline">{{tripChildActivity.Name}}</v-card-title>-->
<!--                                  <v-card-text id="no-padding">-->
<!--                                    {{$translate('EVENT_START_TIME')}}:-->
<!--                                    <b>{{tripChildActivity.StartTime}}</b>-->
<!--                                    , {{$translate('EVENT_END_TIME')}}:-->
<!--                                    <b>{{tripChildActivity.EndTime}}</b>-->
<!--                                    , {{$translate('LINDA_GROUP_SIZE')}}:-->
<!--                                    <b>{{tripChildActivity.GroupSize}}</b>-->
<!--                                  </v-card-text>-->
<!--                                </v-layout>-->
<!--                              </v-layout>-->
<!--                            </v-card>-->
<!--                          </div>-->
<!--                      </template>-->
<!--                      </v-card>-->
<!--                    </template>-->
<!--                  </v-timeline-item>-->
<!--                </template>-->
<!--                <v-timeline-item v-if="plusAfter">-->
<!--                  <template v-slot:icon>-->
<!--                    <v-btn-->
<!--                      fab-->
<!--                      class="v-btn-tiny mr-2"-->
<!--                      color="primary"-->
<!--                      @click="showSuggestionsSelection('Forward')"-->
<!--                    >-->
<!--                      <v-icon>add</v-icon>-->
<!--                    </v-btn>-->
<!--                  </template>-->
<!--                  <span class="test">{{$translate('LINDA_ADD_FOOD_AFTER')}}</span>-->
<!--                </v-timeline-item>-->
<!--              </v-timeline>-->
<!--              <span>{{$translate('DEPARTURE')}}</span>-->
<!--            </template>-->
<!-- Suggestions theme selection dialog -->
            <div class="text-xs-center">
              <v-dialog width="600" pa-2 persistent v-model="showSuggestionsSelectionDialog">
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{$translate('SUGGESTION_MAKE_CHOICE')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                <v-card>
                  <v-layout align-start justify-space-between row class="pa-3">
                      <v-card width="250" flat class="text-xs-center suggestionV_Card" @click="getAllSuggestions('Drinking & Nightlife')">
                        <v-img width="200" class="imagePointer" :src="setPicture('adddrinking')"/>
                        <span class="mt-2 suggestionButtonText">{{$translate('SUGGESTION_DRINKING')}}</span>
                      </v-card>
                      <v-card width="250" flat class="text-xs-center suggestionV_Card" @click="getAllSuggestions('Eating')">
                        <v-img width="200" class="imagePointer" :src="setPicture('addrestaurant')"/>
                        <span class="mt-2 suggestionButtonText">{{$translate('SUGGESTION_EATING')}}</span>
                      </v-card>
                  </v-layout>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      flat
                      @click="showSuggestionsSelectionDialog = false"
                    >{{$translate('CLOSE')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
<!-- Suggestions dialog  -->
            <v-layout row justify-center>
              <v-dialog persistent max-width="700" v-model="suggestionsDialog" scrollable>
                <v-layout column>
                  <v-toolbar v-if="!getSuggestionsBoolean" color="primary" dark>
                    <v-toolbar-title>{{$translate('LIST_OF_SUGGESTIONS')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
<!-- Suggestion loading circle -->
                  <v-card class="suggestionsCard">
                    <v-layout align-center justify-center row fill-height v-if="getSuggestionsBoolean">
                      <v-progress-circular :size="50" :width="7" color="primary" indeterminate></v-progress-circular>
                      <h2
                        id="dialog-text"
                        :style="`color: ${$vuetify.theme.primary}`"
                      >{{$translate('LINDA_SUGGESTIONS_DIALOG')}}</h2>
                    </v-layout>
                    <template>
<!-- Expansion panel for the suggestions -->
                      <v-expansion-panel >
                        <v-expansion-panel-content id="getEventDetails" v-for="(index, item) in suggestions" :key="item">
                          <template v-slot:actions>
                            <v-layout row>
                              <v-divider vertical></v-divider>
                              <v-divider vertical></v-divider>
                              <v-btn round flat v-on:click.stop="bookActivity(item, index)">
                                <v-icon color="primary">add</v-icon>
                              </v-btn>
                            </v-layout>
                          </template>
                          <template class="test2" v-slot:header>
                            <!-- If the image data is empty it has a no image picture -->
                            <v-avatar class="avatar">
                              <img v-if="!index.Picture == ''" :src="index.Picture">
                              <img
                                v-else
                                src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                              >
                            </v-avatar>
                            <v-layout column @click="getEventDetails(index)">
                              <h3>{{index.Name}}</h3>
                            </v-layout>
                          </template>
                          <v-card>
                            <v-layout ma-2 row>
                              <v-card-text class="grey lighten-3">{{eventDescription}}</v-card-text>
                              <!-- If the image data is empty it has a no image picture -->
                              <img
                              max="100"
                                class="suggestionsImage"
                                v-if="!index.Picture == ''"
                                :src="index.Picture"
                              >
                              <img
                                class="suggestionsImage"
                                v-else
                                src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                              >
                            </v-layout>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </template>
                  </v-card>
                  <v-layout class="buttonClose" v-if="!getSuggestionsBoolean">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="closeSuggestions()">{{$translate('CLOSE')}}</v-btn>
                  </v-layout>
                </v-layout>
              </v-dialog>
<!-- No suggestions found dialog -->
              <v-dialog width="500" persistent v-model="noSuggestionsFound">
                <v-card>
                  <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                  >{{$translate('NO_SUGGESTIONS_FOUND')}}</v-card-title>
                  <v-card-text>{{$translate('NO_SUGGESTIONS')}}</v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      flat
                      @click="noSuggestionsFound = false"
                    >{{$translate('CLOSE')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
<!-- Book suggestion failed dialog -->
              <v-dialog width="700" persistent v-model="suggestionFailed">
                <v-card>
                  <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                  >{{$translate('SUGGESTION_BOOK_FAILED')}}</v-card-title>
                  <v-card-text>{{$translate('SUGGESTIONS_NO_PLACES')}}</v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      flat
                      @click="getAllSuggestions(backwardOrForward),suggestionFailed = false"
                    >{{$translate('CLOSE')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
            <br>
            <v-divider></v-divider>
            <br>
            <h3>{{$translate('LINDA_ORDER')}}:</h3>
<!-- Full order list -->
            <div class>
              <template>
                <v-layout row>
                  <v-flex xs12>
                    <template v-for="(suggestions, dataOfSuggestion) in fullTrip">
                      <v-card
                        class="activities elevation-0 transparent scrollableActivities"
                        :key="dataOfSuggestion"
                      >
                        <v-list two-line>
                          <v-list-tile avatar ripple v-if="suggestions.EventId != 0">
                            <!-- If the image data is empty it has a no image picture -->
                            <v-list-tile-avatar>
                              <img v-if="!suggestions.Picture == ''" :src="suggestions.Picture">
                              <img
                                v-else
                                src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                              >
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>{{suggestions.Name}}</v-list-tile-title>
                              <v-list-tile-sub-title>{{suggestions.StartDate}} - {{$translate('TIME')}}: {{suggestions.StartTime}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile>€{{suggestions.Price.toFixed(2)}}</v-list-tile>
                            <v-list-tile>{{suggestions.GroupSize}}x</v-list-tile>
                            <v-list-tile>{{$translate('SUBTOTAL')}}: €{{(suggestions.Price * suggestions.GroupSize).toFixed(2)}}</v-list-tile>
                            <v-list-tile v-if="!suggestions.Price">
                              <v-tooltip top>
                                <template #activator="{ on }">
                                  <v-icon color="grey lighten-1" v-on="on">info</v-icon>
                                </template>
                                <span>
                                  <center>
                                    <strong>{{$translate('TICKET_INFORMATION')}}</strong>
                                  </center>
                                  <center>{{$translate('TICKET_INFORMATION2')}}</center>
                                </span>
                              </v-tooltip>
                            </v-list-tile>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </template>
                    <v-flex xs12 sm12>
                      <v-toolbar class="elevation-0 transparent mr-1">
                        <v-spacer></v-spacer>
                        <h3>{{$translate('TOTAL')}}: € {{order.Price.toFixed(2)}}</h3>
                      </v-toolbar>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout align-end justify-end>
                        <v-btn
                          round
                          class="text-capitalize"
                          @click="cancelOrder = true"
                          color="secondary"
                        >{{$translate('CANCEL')}}</v-btn>
                        <v-btn
                          round
                          class="text-capitalize"
                          @click="acceptTrip()"
                          color="primary"
                        >{{$translate('CONFIRM')}}</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center">
                  <v-dialog width="500" persistent v-model="cancelOrder">
                    <v-card>
                      <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                      >{{$translate('CANCEL_YOUR_ORDER')}}</v-card-title>
                      <v-card-text>{{$translate('CANCEL_YOUR_ORDER_ACCEPT')}}</v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          flat
                          @click="cancelOrder = false"
                        >{{$translate('NO_IM_NOT')}}</v-btn>
                        <v-btn
                          color="primary"
                          flat
                          @click="acceptTrip('cancel order')"
                        >{{$translate('YES_I_AM')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </template>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import NewToolbar from "@/components/NewToolbar";
import { store } from "../store";
import Homepage from "@/components/EventRegistration/Homepage";
import animate from "animate.css";
import CpFooter from "./CpFooter";
import appConfig from "../../config/app_config.js";
import * as dssRequest from "../api/dssRequest";
import BaseObject from "../objects/BaseObject";
import BaseComponent from "./base/BaseComponent.vue";
import { ui_helpers } from "../shared/ui_helpers.js";
import Sortable from "sortablejs";
import _ from "lodash";
export default {
  computed: {
    ...mapGetters({
      language: "getLanguage",
      userLanguageId: "getUserLanguage"
    }),
    openCloseTour() {
    return !this.tourOpened ? "Open tour" : "Close tour";
    }
  },
  data() {
    return {
      //Needed for the suggestion part
      tourOpened           : false,
      showSuggestionsSelectionDialog: false,
      plusAfter            : true,
      plusBefore           : true,
      suggestionFailed     : false,
      suggestionBefore     : {},
      suggestionAfter      : {},
      suggestionId         : {},
      removeSuggestion     : false,
      noSuggestionsFound   : false,
      getSuggestionsBoolean       : false,
      suggestions          : {},
      backwardOrForward     : '',
      suggestionsDialog    : false,

      //Rules
      formRules            : [v => !!v || "This field is required"],
      departureRules       : [v => !!v || "This field is required"],
      groupSizeRules       : [
        v => !!v || "This field is required",
        v => (v && v > 0) || "Your group can not be 0 or a negative number"
      ],

      //For the calendar part
      calendarFullScreenDialog: true,
      showCalendar      : false,
      extraEventInfo: false,
      chosenEventId: "",
      chosenDate: "",
      chosenBatchGroupId: '',

      //Messages and dialogs
      alertDialog          : false,
      timeInCorrect        : false,
      showProgressText     : true,
      showProgessCircle    : true,
      groupSizeDialog      : false,
      noEventsFound        : false,
      confirmOrderDialog: false,

      //stepper
      stepperSteps: 1,

      //Order
      cantBookBatch: false,
      remark: '',
      userInputs: {},
      freeTripDialog: false,
      showLoading: false,
      orderOverview: false,
      emptyInputs: false,
      userOrder            : {},
      order            : {},
      cancelOrder          : false,
      fullTrip             : {},
      showOrder         : false,

      //To show the event with the data
      currentBatch: {},
      eventDescription: '',
      eventPicture    : '',
      NoFrequency     : 0,
      transport       : {},
      partnerName     : "",
      showEventData   : false,
      eventData       : {},
      typesOfTrans    : [],
      allBatches: {}
    };
  },

  mounted() {
    if(this.$store.getters.getBookingData.Data == undefined){
      this.$router.push({
        name: "Homepage",
        params: {
          account_id: this.$store.getters.getRegion
        }
      });
    }
    this.getCalendar(this.getCurrentDate(), this.getNextMonthFromToday());
    if (!_.isEmpty(this.$store.getters.getBookingData)) {
      this.getEventDetails(this.$store.getters.getBookingData.Data, this.$store.getters.getBookingData.Date, this.$store.getters.getBookingData.Boolean)
    }

    this.$store.commit("setRedirectedFromPearlCalendar", true);
    // this.getFavourites();
    // this.addFavourite();
    // this.deleteFavourite()
  },
  methods: {
    goToSecondStep(){
      const tickets = {};
      for (let [key, value] of Object.entries(this.eventData.PriceCategories)) {
        if (value.Amount > "0")  {
          Object.assign(tickets,
            {
              [value.Id] :Number(value.Amount)
            })
        }
      }
      if(_.isEmpty(tickets)){
        this.emptyInputs = true
        return
      }
      else {
        this.stepperSteps = 2;
        this.getBatches();
      }
    },
    Get(url){
      var Httpreq = new XMLHttpRequest(); // a new request
      Httpreq.open("GET",url,false);
      Httpreq.send(null);
      return Httpreq.responseText;
    },
    bookBatch(){
      if(this.userInputs[19] == '' || this.userInputs[17] == '' || this.userInputs[14] == '' || this.userInputs[15] == '' || _.isEmpty(this.currentBatch)){
        this.emptyInputs = true;
        return
      }
      var json_obj = JSON.parse(this.Get('https://nominatim.openstreetmap.org/search?q=' + this.userInputs[15] + '+' + this.userInputs[14] + ',+' + this.userInputs[17] + '&format=json&polygon=1&addressdetails=1'));
      if(!_.isEmpty(json_obj)){
        const lat = json_obj[0].lat;
        const lon = json_obj[0].lon;
        this.$store.commit("setUserOrderLon", lon);
        this.$store.commit("setUserOrderLat", lat);
        this.userInputs.Longitude = Number(this.$store.getters.getUserOrderLon)
        this.userInputs.Latitude = Number(this.$store.getters.getUserOrderLat)
      }
      else {
        return;
      }
      let adressInfo = {
        PhoneNumber: this.userInputs[8],
        City: this.userInputs[17],
        Street: this.userInputs[14],
        Nr: this.userInputs[15],
        Latitude: this.userInputs.Latitude,
        Longitude:  this.userInputs.Longitude
      }
      const tickets = {};
      for (let [key, value] of Object.entries(this.eventData.PriceCategories)) {
        if (value.Amount > "0")  {
          Object.assign(tickets,
            {
              [value.Id] :Number(value.Amount)
            })
        }
      }
      if(_.isEmpty(tickets)){
        this.emptyInputs = true
        return
      }
      const payload = {
        StartDate: this.chosenDay || this.$store.getters.getBookingData.Date,
        EventId: Number(this.$store.getters.getBookingData.Data.EventId),
        BatchId: this.currentBatch.BatchId,
        Tickets: tickets,
        AddressInfo: adressInfo,
        Note: this.remark
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call bookBatch was successful",
            response
          );
          this.orderOverview = true;
          this.userOrder = response.data;
          this.stepperSteps = 3
        },
        error => {
          console.log(
            "The generic call bookBatch was not successful",
            error
          );
          this.cantBookBatch = true
        },
        "bookBatch",
        this.$store.getters["auth/userName"],
        payload,
        600000,
        false
      );
    },
    getBatches() {
      const payload = {
        StartDate: this.$store.getters.getBookingData.Date,
        EndDate: this.$store.getters.getBookingData.Date,
        StartTime: '00:00',
        EndTime: '23:59',
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getBatches was successful",
            response
          );
          let recievedBatches = Object.values(response.data.Batches);
          recievedBatches.forEach((e => {
            e.TotalTime = (e.StartTime + " - " + e.EndTime)
          }))
          this.allBatches = recievedBatches;

        },
        error => {
          console.log(
            "The generic call getBatches was not successful",
            error
          );
        },
        "getBatches",
        Number(this.$store.getters.getBookingData.Data.EventId),
        payload
      );
    },
    createCalendarArrayOfItems(data) {
      this.calendarItems = [];
      // Adding the date to the events and saving the events in array calendarItems
      let recievedData = data;
      for (const [key, value] of Object.entries(recievedData)) {
        value.forEach((element, innerKey) => {
          element.eventDate = key;
          this.calendarItems.push(element);
        });
      }
    },
    getFavourites() {
      let payload = {}
      dssRequest.doRequest(
        response => {
          console.log("the call for `getFavourites` was successful", response);
        },
        error => {
          console.log(
            "the call for getFavourites was not successful",
            error
          );
        },
        "getFavourites",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    addFavourite() {
      let payload = {
        EventId:  527
      }
      dssRequest.doRequest(
        response => {
          console.log("the call for `addFavourite` was successful", response);
        },
        error => {
          console.log(
            "the call for addFavourite was not successful",
            error
          );
        },
        "addFavourite",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    deleteFavourite() {
      let payload = {
        EventId:  527
      }
      dssRequest.doRequest(
        response => {
          console.log("the call for `deleteFavourite` was successful", response);
        },
        error => {
          console.log(
            "the call for deleteFavourite was not successful",
            error
          );
        },
        "deleteFavourite",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    setPicture(data) {
    //This function will set the picture for the suggestion selection
       let fileType = ".png";
        return require("../assets/" + data + fileType);
    },
    getEventDetails(data, key, showBookDialog) {
      if (this.chosenEventId == data.EventId && this.chosenDate == key && !showBookDialog) {
        this.extraEventInfo = false;
        this.chosenEventId = "";
        this.chosenDate = "";
        this.chosenBatchGroupId = ''
        return;
      } else {
        this.extraEventInfo = false;
        setTimeout(() => {
          this.extraEventInfo = true;
        }, 10);
      }
      this.eventPicture = data.Picture
      this.chosenEventId = data.EventId;
      this.chosenDate = key;
      this.chosenBatchGroupId = data.BatchGroupId
    // When selecting an event this function will be called

      const payload = {
        LanguageTagId: this.$store.getters.getUserLanguage
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getEventDetails was successful",
            response
          );
          if(_.isEmpty(this.$store.getters.getUserCalendarCache)){
           this.eventData = response.data
          }
          this.eventPicture = response.data.Picture
          this.eventData.Picture = data.picture;
          this.eventDescription = response.data.Description
          this.order.EventId = response.data.EventId
          if(showBookDialog){
            this.showEvent(data, key)
          }
        },
        error => {
          console.log(
            "The generic call getEventDetails was not successful",
            error
          );
        },
        "getEventDetailsV2",
        Number(data.EventId),
        payload
      );
    },
    cancelOrderFunction() {
      // This function cancelled the order
      if (!_.isEmpty(this.order.OrderId)) {
        const payload = {
          Runtime: true,
          TripId    : this.order.TripId,
          OrderId   : this.order.OrderId,
          FunctionId: "EventFunctionLibrary::cancelOrder",

        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call cancelOrder was successful",
              response
            );
            this.$store.commit("setUserCalendarCache", {});
            this.showCalendar = true,
            this.showOrder    = false;
            this.plusAfter    = true
            this.plusBefore   = true
          },
          error => {
            console.log(
              "The generic call cancelOrder was not successful",
              error
            );
          },
          "cancelOrder",
          this.$store.getters["auth/userName"],
          payload
        );
      }
    },
    getFullTrip() {
   // This function will get the full trip with all the activities and suggestions
      const payload = {
        Runtime: true,
        TripId   : this.order.TripId,
      };
      dssRequest.doRequest(
        response => {
          this.fullTrip = response.data.Activities;
          console.log("The generic call getFullTrip was successful", response);
          this.order.Price = 0

          for(let [index, item] of Object.entries(this.fullTrip)){
            this.order.Price = this.order.Price + (item.Price * item.GroupSize)
          }
          this.showEventData = false;
          this.showOrder = true;
        },
        error => {
          console.log("The generic call getFullTrip was not successful", error);
        },
        "getFullTrip",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    closeSuggestions() {
    // This function will close the dialog with all the suggestions
      this.suggestions = {},
      this.suggestionsDialog = false;
    },
    bookActivity(item, index) {
    // With this function you will book the selected suggestion
      this.closeSuggestions();
      const payload = {
        Runtime       : true,
        TripId        : this.order.TripId,
        EventId       : Number(index.EventId),
        BookType      : Number(index.BookType),
        Direction     : this.backwardOrForward,
        GroupSize     : Number(this.eventData.groupSize),
        BookType      : index.BookType,
        SeqNr: this.backwardOrForward == 'Backward' ? 0 : Object.keys(this.fullTrip).pop()-1,
      };
      dssRequest.doRequest(
        response => {
          if (this.backwardOrForward == "Backward") {
            this.plusBefore = false
            this.suggestionBefore = payload
          } else if (this.backwardOrForward == "Forward") {
            this.plusAfter = false
            this.suggestionAfter = payload
          }
          console.log("The call for bookActivity was successful", response);
          this.getFullTrip();
          console.log("getFullTrip is called from bookActivity")
          this.closeSuggestions();
        },
        error => {
          console.log("The call for bookActivity was not successful", error);
          this.suggestionsDialog = false;
          this.suggestionFailed  = true;
          this.suggestions       = {};
        },
        "bookActivity",
        this.$store.getters["auth/userName"],
        payload,
        600000,
        false
      );
    },
    showSuggestionsSelection(backwardOrForward, ){
      this.showSuggestionsSelectionDialog = true
      this.backwardOrForward = backwardOrForward
    },
      getAllSuggestions(typeOfSuggestion) {
      console.log("FullTrip", this.fullTrip, Object.keys(this.fullTrip).pop()-2, Object.keys(this.fullTrip).pop()-1)
    // This function will get the list with all the possible suggestions
      this.showSuggestionsSelectionDialog = false;
      this.suggestionsDialog = true;
      this.getSuggestionsBoolean = true;
      let payload = {
        Runtime      : true,
        TripId       : this.order.TripId,
        Direction     : this.backwardOrForward,
        GroupSize     : Number(this.eventData.groupSize),
        TagGroup     : typeOfSuggestion,
        SeqNr: this.backwardOrForward == 'Backward' ? 0 : Object.keys(this.fullTrip).pop()-1,
      };
      dssRequest.doRequest(
        response => {
          this.getSuggestionsBoolean = false;
          console.log("The call for getSuggestions was successful", response);
          this.suggestions = response.data.Suggestions;
          if (_.isEmpty(this.suggestions)) {
            this.noSuggestionsFound = true;
            this.suggestionsDialog = false;
          }
        },
        error => {
          console.log("The call for getSuggestions was not successful", error);
        },
        "getSuggestions",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    acceptTrip(data) {
    // This function has to be called before confirming the order
      const payload = {
        Runtime: true,
        FunctionId: "EventFunctionLibrary::acceptTrip",
        TripId    : this.order.TripId,
      };
      dssRequest.doRequest(
        response => {
          console.log("The call for acceptTrip was successful", response);
          if (data !== "cancel order") {
            this.showLoading = false;
            this.confirmOrderLoading();
            this.order.OrderId = response.data.OrderId;
          } else if (data == "cancel order") {
            this.order.OrderId = response.data.OrderId;
            this.cancelOrderFunction();
          }
        },
        error => {
          console.log("The call for acceptTrip was not successful", error);
        },
        "acceptTrip",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    getPartner() {
    // This function will be called to get the partner name
      const payload = {
        PartnerId: this.$route.params.partner_id
      };
      dssRequest.doRequest(
        response => {
          console.log("the call for getPartner was successful", response);
          if (!_.isEmpty(response.data)) {
            this.partnerName = response.data.Partner.celldata[0][1];
            this.getPartnerPreferences();
            setTimeout(() => {
              this.getCalendar();
            }, 100);
          }
        },
        error => {
          console.log("the call for getPartner was not successful", error);
        },
        "getPartner",
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false
      );
    },
    confirmOrderLoading() {
    // These 2 function will be called when you confirm your order
      this.confirmOrderDialog = true;
      setTimeout(() => {
        this.confirmOrder();
      }, 10);
    },
    confirmOrder() {
      store.commit("setOrderId", this.userOrder.OrderId);
      this.confirmOrderDialog = false;
      const payload = {
        Runtime: true,
        TripId   : this.order.TripId,
        OrderId  : this.userOrder.OrderId,
      };
      dssRequest.doRequest(
        response => {
          console.log("The call for confirmOrder was successful", response);
          this.showLoading = false;
          if (
            response.data.hasOwnProperty("PaymentId") &&
            response.data.hasOwnProperty("PaymentUrl")
          ) {
            this.$store.commit("setTripFormPaymentId", response.data.PaymentId);
            if (this.userOrder.OrderTotalPrice.toFixed(2) !== "0.00") {
              const path = response.data.PaymentUrl;
              window.location = path;
            } else {
              this.goTo("MainEventInfo");
              this.$store.commit("setWebStepId", 2);
            }
          } else {
            console.log("confirmed tirp without payment");
            this.goTo("UserTripList");
          }
        },
        error => {
          console.log("The call for confirmOrder was not successful", error);
          this.$store.commit("setWebStepId", 6);
        },
        "confirmOrder",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    getTransportationTypesForEvent() {
    // this function will get the transport types for the event
      let payload = {};
      this.typesOfTrans = [];
      if (!_.isEmpty(this.$store.getters.getUserCalendarCache)) {
        payload = {
          EventId   : this.$store.getters.getUserCalendarCache.EventId,
          FunctionId: "EventFunctionLibrary::getTransportationTypesForEvent"
        };
      } else {
        payload = {
          EventId   : this.eventDetails.EventId,
          FunctionId: "EventFunctionLibrary::getTransportationTypesForEvent"
        };
      }
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getTransportationTypesForEvent was successful",
            response
          );
          if (_.isEmpty(response.data)) {
            this.typesOfTrans.push({ Tag: 0, Description: "Walking" });
            this.eventData.modeOfTransport = this.typesOfTrans[0];
          } else {
            let recievedTransportObject = {};
            for (let [key, value] of Object.entries(response.data)) {
              this.typesOfTrans.push(value);
            }
            this.eventData.modeOfTransport = this.typesOfTrans[0];
          }
        },
        e => {
          console.log(
            "The generic call getTransportationTypesForEvent was not successful",
            error
          );
        },
        "getTransportationTypesForEvent",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getCurrentDate() {
    //this function is called to get the current day to call the funtion getCalendar()
      const toTwoDigits = num => (num < 10 ? "0" + num : num);
      let today = new Date();
      let year = today.getFullYear();
      let month = toTwoDigits(today.getMonth() + 1);
      let day = toTwoDigits(today.getDate());
      return day + "-" + month + "-" + year;
    },
    showEvent(data, key) {

    //This funciton will be called when you selected an event
      const toSendData = {
        BatchFrequency: data.BatchFrequency,
        CooldownTime: data.CooldownTime,
        LeadTime: data.LeadTime,
        EventId: data.EventId,
        TransportId: Number(this.transport),
        BatchGroupId: data.BatchGroupId,
        StartDate: key,
        StartTime: data.StartTime,
        EndTime: data.EndTime,
        GroupSize: 1,
        EventEndTime: data.EndTime
      };
      this.$store.commit("setEventDetailsSaved", data);

      this.showCalendar = false;
      this.showEventData = true;
      this.eventDetails = data;
      if (_.isEmpty(this.$store.getters.getUserCalendarCache)) {
        this.eventData.arrivalTime = data.StartTime;
        this.eventData.departureTime = data.EndTime;
        this.eventData.groupSize = 1;
        this.eventData.modeOfTransport = 0;
        this.NoFrequency = data.BatchFrequency;
      }
      else {
          this.eventData.arrivalTime = this.$store.getters.getUserCalendarCache.ArrivalTime;
          this.eventData.departureTime = this.$store.getters.getUserCalendarCache.EndTime;
          this.eventData.transportId = this.$store.getters.getUserCalendarCache.TransportId;
          this.eventData.groupSize = this.$store.getters.getUserCalendarCache.GroupSize;
      }
      this.eventDetails.ArrivalDate = key;
      this.getTransportationTypesForEvent();
    },
    getCalendarBack() {
    // After selecting an event and then press cancel this function will be called
      this.$store.commit("setEventDetailsSaved", {});
      this.showCalendar = true
      this.showEventData = false;
      this.$store.commit("setUserCalendarCache", {});
      this.$refs.eventData.reset();
    },
    getInputBack() {
    //Pressing the cancel button
      this.showOrder = false;
      this.showEventData = true;
    },
    getPartnerPreferences() {
      const payload = {
        PartnerId: Number(this.$store.getters.getSavePartnerId)
      };

      dssRequest.doRequest(
        response => {
          let result = BaseObject._createArrayWithObjects(
            response.data.PartnerPreferences
          );

          const currentPartnerPreferencesObjects = result.map(
            ({ Key, Type, Value }) => ({ Key, Type, Value })
          );

          console.log(
            "partner prefobjects: ",
            currentPartnerPreferencesObjects
          );
          let prefs = {};
          currentPartnerPreferencesObjects.map(e => (prefs[e.Key] = e.Value));
          this.$store.commit("setCustomerPreferences", prefs);
          this.$store.commit("setBackgroundImage", prefs.Background_image);
        },
        error => {
          console.log("getPartnerPreferences error", error);
        },
        "getPartnerPreferences",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },
    getNextMonthFromToday() {
      // This function is called to return the week after today for getCalendar
      const toTwoDigits = num => (num < 10 ? "0" + num : num);
      let today = new Date();
      today.setDate(today.getDate() + 30);
      let year = today.getFullYear();
      let month = toTwoDigits(today.getMonth() + 1);
      let day = toTwoDigits(today.getDate());
      return day + "-" + month + "-" + year;
    },
    getCurrentDate() {
      //this function is called to get the current day to call the funtion getCalendar()
      const toTwoDigits = num => (num < 10 ? "0" + num : num);
      let today = new Date();

      let year = today.getFullYear();
      let month = toTwoDigits(today.getMonth() + 1);
      let day = toTwoDigits(today.getDate());
      return day + "-" + month + "-" + year;
    },
    getCalendar(recievedStartDate, recievedEndDate) {

      let userLanguage = this._userLanguage;
      let object = "";
      let payload = {};
      // this function will get the calendar for a specific partner or account
      if (
        !_.isEmpty(this.$store.getters.getUserCalendarCache) ||
        !_.isEmpty(this.$store.getters.getEventDetailsSaved)
      ) {
        this.NoFrequency = this.$store.getters.getEventDetailsSaved.BatchFrequency;
      }
      if (this.$store.getters["auth/userName"] == "") {
        if (this.$store.getters.getSavePartnerId !== "") {
          object =
            this.$store.getters.getCurrentAccountId +
            "_UG_" +
            this.$store.getters.getSavePartnerId;
        } else {
          object = this.$store.getters.getCurrentAccountId;
        }
        payload = {
          StartDate: recievedStartDate,
          EndDate: recievedEndDate,
          LanguageTagId: Number(userLanguage)
        };
      } else {
        object = this.$store.getters["auth/userName"];

        if (Number(userLanguage) === null || userLanguage == undefined) {
          userLanguage = Number(13);
        }
        payload = {
          Runtime: true,
          StartDate: recievedStartDate,
          EndDate: recievedEndDate,
          LanguageTagId: Number(userLanguage)
        };
      }
      if (
        (!_.isEmpty(this.$store.getters.getUserCalendarCache) &&
          this.$store.getters.getRedirectedFromPearlCalendar) ||
        !_.isEmpty(this.$store.getters.getEventDetailsSaved)
      ) {
        this.showProgressText = false;
      }

      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call for getCalendar was successful",
            response
          );
          this.showProgessCircle = false;
          if (!_.isEmpty(response.data.Calendar)) {
            if (
              !_.isEmpty(this.$store.getters.getUserCalendarCache) &&
              this.$store.getters.getRedirectedFromPearlCalendar
            ) {
              for (let [index, item] of Object.entries(
                response.data.Calendar
              )) {
                if (
                  index == this.$store.getters.getUserCalendarCache.ArrivalDate
                ) {
                  for (let [innerIndex, innerItem] of Object.entries(item)) {
                    if (
                      innerItem.EventId ==
                      this.$store.getters.getUserCalendarCache.EventId &&
                      this.$store.getters.getEventDetailsSaved.BatchGroupId ==
                      innerItem.BatchGroupId
                    ) {
                      this.getEventDetails(innerItem, index, false);
                    }
                  }
                }
                if (!_.isEmpty(item)) {
                  if (!_.isEmpty(response.data.Pictures)) {
                    for (let [indexItem, itemItem] of Object.entries(item)) {
                      for (let [indexPicture, itemPicture] of Object.entries(
                        response.data.Pictures
                      )) {
                        if (itemItem.PictureId == indexPicture) {
                          itemItem.Picture = itemPicture;
                        }
                      }
                    }
                  }
                }
              }
            } else if (!_.isEmpty(this.$store.getters.getEventDetailsSaved)) {
              for (let [index, item] of Object.entries(
                response.data.Calendar
              )) {
                if (
                  index == this.$store.getters.getEventDetailsSaved.StartDate
                ) {
                  for (let [innerIndex, innerItem] of Object.entries(item)) {
                    if (
                      innerItem.EventId ==
                      this.$store.getters.getEventDetailsSaved.EventId &&
                      this.$store.getters.getEventDetailsSaved.EventEndTime ==
                      innerItem.EndTime
                    ) {
                      this.eventData.arrivalTime = this.$store.getters.getEventDetailsSaved.StartTime;
                      this.eventData.departureTime = this.$store.getters.getEventDetailsSaved.EndTime;
                      this.eventData.transportId = this.$store.getters.getEventDetailsSaved.TransportId;
                      this.eventData.groupSize = this.$store.getters.getEventDetailsSaved.GroupSize;
                      this.getEventDetails(innerItem, index, false);
                    }
                  }
                }
                if (!_.isEmpty(item)) {
                  if (!_.isEmpty(response.data.Pictures)) {
                    for (let [indexItem, itemItem] of Object.entries(item)) {
                      for (let [indexPicture, itemPicture] of Object.entries(
                        response.data.Pictures
                      )) {
                        if (itemItem.PictureId == indexPicture) {
                          itemItem.Picture = itemPicture;
                        }
                      }
                    }
                  }
                }
              }
            } else {
              let ewg = {};
              let d = this.$store.getters.getThemeListEventId;
              for (let [index, item] of Object.entries(
                response.data.Calendar
              )) {
                if (!_.isEmpty(item)) {
                  if (!_.isEmpty(response.data.Pictures)) {
                    for (let [indexItem, itemItem] of Object.entries(item)) {
                      for (let [indexPicture, itemPicture] of Object.entries(
                        response.data.Pictures
                      )) {
                        if (itemItem.PictureId == indexPicture) {
                          itemItem.Picture = itemPicture;
                        }
                      }
                    }
                  }
                  if (d !== 0) {
                    for (let [innerIndex, innerItem] of Object.entries(item)) {
                      if (innerItem.EventId == d) {
                        item = innerItem;
                        ewg[index] = { [innerIndex]: item };
                        response.data.Calendar = ewg;
                      }
                    }
                  }
                }
              }
            }
            // to sort the calendar
            var ordered = {};
            var object = {};
            Object.keys(response.data.Calendar)
              .sort(function(a, b) {
                return dateConverter(a) - dateConverter(b);
              })
              .forEach(function(key) {
                ordered[key] = response.data.Calendar[key];
              });
            for (const [key, value] of Object.entries(ordered)) {
              let array = [];
              for (const innerValue of Object.values(value)) {
                array.push(innerValue);
                object[key] = array;
              }
              for (const [innerKeyTwo, innerValueTwo] of Object.entries(
                object
              )) {
                innerValueTwo.sort(compare);
              }
            }
            function compare(a, b) {
              const bandA = a.StartTime;
              const bandB = b.StartTime;

              let comparison = 0;
              if (bandA > bandB) {
                comparison = 1;
              } else if (bandA < bandB) {
                comparison = -1;
              }
              return comparison;
            }
            ordered = object;

            /* Convert DD/MM/YY to date object */
            function dateConverter(date) {
              var dateParts = date.split("-");
              var dateObject = new Date(
                +dateParts[2],
                dateParts[1] - 1,
                +dateParts[0]
              );
              return dateObject;
            }

            this.$store.commit("setCalendar", ordered);
            this.createCalendarArrayOfItems(ordered);
          }

          if (_.isEmpty(response.data.Calendar)) {
            this.noEventsFound = true;
          }
        },
        error => {
          console.log(
            "The generic call for getCalendar was not successful",
            error
          );
        },
        "getCalendar",
        object,
        payload
      );
    },


    newTrip() {
    //This function will book the selected activity
      this.cancelOrder = false;
      if (this.eventData.modeOfTransport.hasOwnProperty("Tag")) {
        this.transport = this.eventData.modeOfTransport.Tag;
      } else if (!this.eventData.modeOfTransport.hasOwnProperty("Tag")) {
        this.transport = this.eventData.modeOfTransport;
      }
      let startTime = Number(this.eventData.arrivalTime.replace(":", ""));
      let endTime = Number(this.eventData.departureTime.replace(":", ""));
      if (startTime > endTime) {
        this.timeInCorrect = true;
        return;
      }
      let userId = "";
      let payload = {
        Runtime       : true,
        EventId       : Number(this.eventDetails.EventId),
        ArrivalDate     : this.eventDetails.ArrivalDate,
        ArrivalTime     : this.eventData.arrivalTime,
        GroupSize     : Number(this.eventData.groupSize),
        EndTime       : this.eventDetails.EndTime

      };
      if (
        payload.ArrivalTime === undefined ||
        payload.ArrivalTime === "" ||
        isNaN(payload.GroupSize) ||
        payload.GroupSize <= 0 ||
        payload.GroupSize > this.eventDetails.FreePlaces
      ) {
        this.alertDialog = true;
      }
      if (this.$store.getters["auth/userName"] === "") {
        // User not logged in, go to login page
        this.$store.commit("setUserCalendarCache", payload);
        this.goTo("Login");
      } else {
        if (!this.$refs.eventData.validate()) {
          alert = "You forgot someting";
        } else {
          if (!this.$refs.eventData.validate()) {
            alert = "You forgot someting";
          }
          dssRequest.doRequest(
            response => {
               console.log(
                "The generic call for newTrip was successful",
                response
              );
              if (response.data.ReturnValue === "No capacity") {
                this.groupSizeDialog = true;
                return;
              } else {
                this.order.TripId = response.data.TripId

                this.getFullTrip();
              }
            },
            error => {
              console.log(
                "The generic call for newTrip was not successful",
                error
              );
            },
            "newTrip",
            this.$store.getters["auth/userName"],
            payload,
            600000,
            false
          );
        }
      }
    },
    goTo(page) {
      // Generic function to let the user move to other components
      this.$router.push({
        name: page,
        params: "component"
      });
    }
  }
};
</script>
<style>
.v-progress-circular {
  margin: 1rem;
}
#places {
  font-size: 14px;
  color: red;
}
#price {
  color: black;
  font-size: 18px;
}
#screen {
  margin-bottom: 5em;
  border-radius: 3em;
  max-height: 750px !important;
}
#showOrder {
  margin-bottom: 5em;
  border-radius: 3em;
}
#v-card {
  box-shadow: none;
  padding-bottom: 3em;
}
.tourElements {
  padding-left: 6px solid red;
}
.notificationList {
  max-height: calc(80vh - 100px) !important;
  border-radius: 0 !important;
  background-color: #cfcfcf !important;
}
.date {
  font-size: 18px !important;
  color: black !important;
  background-color: #ededed;
  margin: 0 !important;
  padding: 0.5em;
  max-width: 7em !important;
}
.date:hover{
 background-color: #c1bfbf;
}
.without_ampm::-webkit-datetime-edit-ampm-field {
  display: none;
}
#dialog-text {
  text-align: center;
}
#no-padding {
  padding: 0;
}
.activities {
  max-height: 180px !important;
}
.scrollableActivities {
  overflow-y: auto;
  overflow-x: hidden;
}
.suggestionsCard {
  max-height: 400px !important;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  box-shadow: none !important;
}
.buttonClose {
  background-color: white;
}
.v-expansion-panel__header {
  padding: 5px 2px !important;
}
.suggestionsTime {
  font-size: 15px;
  margin-bottom: 0;
}
.suggestionsImage {
  max-width: 20em;
  max-height: 10em;
  margin-top: 16px;
}
.avatar {
  margin-bottom: 1.5em;
  max-width: 75px !important;
  min-width: 75px !important;
}
.suggestionsDescriptionSmall {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 25em;
  margin-bottom: 0;
}
.avatarOfCalendar {
  max-width: 95px;
  margin-top: 0.8em;
}
.v-expansion-panel__container{
  margin: 4px 0 !important;
}
.v-expansion-panel {
  box-shadow: none !important;
}
@media (max-width: 1000px) {
  .calendar-expansion-content {
    display: flex !important;
    flex-direction: column !important;
    padding: 0.5em;
  }
  .calendar-expansion-content img {
    margin-left: 3em !important;
  }
  .v-expansion-panel__header {
    display: flex !important;
    flex-direction: column !important;
  }
  .v-expansion-panel__header h3 {
    font-size: 1em !important;
  }
  .v-expansion-panel__header p {
    max-width: 20em;
  }
  .eventBlock {
    max-height: 600px !important;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .eventBlock-Name {
    font-size: 1.2em !important;
  }
  #showOrder {
    width: 600px !important;
  }
  .order {
    margin-left: 5em !important;
  }
}
@media (max-width: 1200px) {
  #showOrder {
    width: 600px !important;
  }
}
@media (min-height: 1200px) {
  .eventBlock {
    max-height: 200px !important;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
.imagePointer {
  cursor: pointer;
  margin: 0 auto;
}
.suggestionButtonText {
  font-size: 16px;
}
.suggestionV_Card {
  padding-top: 1.5em;
  box-shadow: 0 0 5px #333 !important;
}
.descriptionV_Card {
  max-height: 19em;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 1em;
}
.descriptionV_Card p {
  padding-right: 1em;
}
#getEventDetails{
  cursor: pointer;
}
#getEventDetails:hover {
  background-color: lightgrey;
}
#bookButtonCalendar:hover {
  transform: scale(1.05);
}
  .calendar-expansion-content {
    cursor: auto;
  }
.imageForEvent {
  border-radius: 1em;
  margin-left: 10em;
}
</style>
